import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import FpsFinder from "@/pages/FpsFinder";
import DeviceDetail from "@/pages/DeviceDetail";
import Category from "@/pages/Category";
import Brand from "@/pages/Brand";
import Compare from "@/pages/Compare";
import Blog from "@/pages/Blog";
import GuideDetail from "@/pages/GuideDetail";
import PriceIndex from "@/pages/PriceIndex";
import Glossary from "@/pages/Glossary";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/fps-finder" element={<FpsFinder />} />
                  <Route path="/device/:slug" element={<DeviceDetail />} />
                  <Route path="/category/:slug" element={<Category />} />
                  <Route path="/brand/:slug" element={<Brand />} />
                  <Route path="/compare" element={<Compare />} />
                  <Route path="/compare/:slugA/:slugB" element={<Compare />} />
                  <Route path="/guides" element={<Blog />} />
                  <Route path="/guides/:slug" element={<GuideDetail />} />
                  <Route path="/price-index" element={<PriceIndex />} />
                  <Route path="/glossary" element={<Glossary />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
